(function () {
    'use strict';

    /**
     * Video (live hall) section - owns its state.
     * Used as an attribute on the server rendered <section> (Views/Events/_Video.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "videoSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionVideo', sectionVideo);

    function sectionVideo() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionVideoCtrl,
            controllerAs: 'videoSection'
        };
    }

    SectionVideoCtrl.$inject = ['$element', 'SectionRegistry'];

    function SectionVideoCtrl($element, SectionRegistry) {
        const vm = this;
        // the hall player (ng-if) is created only when the section is in view
        vm.showHall = false;

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Show the hall player - no api call, ea-hall loads its own data
         */
        function load() {
            vm.showHall = true;
        }
    }
})();
